document.addEventListener("DOMContentLoaded", () => {
    const { DateTime } = luxon;

    class CountdownTimer extends HTMLElement {
        connectedCallback() {
        // Read data attributes
        this.year = this.getAttribute('data-year');
        this.month = this.getAttribute('data-month');
        this.day = this.getAttribute('data-day');
        this.hour = this.getAttribute('data-hour');
        this.minute = this.getAttribute('data-minute');
        this.hideTimer = this.getAttribute('data-hide-timer') === 'true';
        this.completeMessage = this.getAttribute('data-complete-message');
        this.parentEl = this.closest('.announcement-bar__counter');


        // Get element references
        this.display = this.querySelector('[data-time-display]');
        this.daysEl = this.querySelector('[data-days-placeholder]');
        this.hoursEl = this.querySelector('[data-hours-placeholder]');
        this.minutesEl = this.querySelector('[data-minutes-placeholder]');
        this.secondsEl = this.querySelector('[data-seconds-placeholder]');
        this.messageEl = this.querySelector('[data-message-placeholder]');

        // Check for required elements
        if (!this.display || !this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
            console.error('One or more countdown placeholders are missing.');
            return;
        }

        this.startTimer();
        }

        startTimer() {
        this.updateTime();
        this.timerInterval = setInterval(() => this.updateTime(), 1000);
        }

        updateTime() {
        const target = DateTime.fromObject(
            {
            year: parseInt(this.year),
            month: parseInt(this.month),
            day: parseInt(this.day),
            hour: parseInt(this.hour),
            minute: parseInt(this.minute),
            second: 0
            },
            { zone: 'America/New_York' }
        );

        const now = DateTime.now().setZone('America/New_York');
        const diff = target.diff(now, ['days', 'hours', 'minutes', 'seconds']);

        if (diff.toMillis() <= 0) {
            clearInterval(this.timerInterval);
            this.daysEl.textContent = '00';
            this.hoursEl.textContent = '00';
            this.minutesEl.textContent = '00';
            this.secondsEl.textContent = '00';

            if (this.hideTimer) {
                this.display.classList.add('countdown__hidden');
                if (this.parentEl) this.parentEl.classList.add('countdown__hidden');
                this.display.classList.remove('countdown__display--visible');
            }

            if (this.completeMessage && this.messageEl) {
                this.messageEl.textContent = this.completeMessage;
                this.messageEl.style.display = 'block';
            }

            return;
        }

        this.daysEl.textContent = String(Math.floor(diff.days)).padStart(2, '0');
        this.hoursEl.textContent = String(Math.floor(diff.hours)).padStart(2, '0');
        this.minutesEl.textContent = String(Math.floor(diff.minutes)).padStart(2, '0');
        this.secondsEl.textContent = String(Math.floor(diff.seconds)).padStart(2, '0');
        }
    }

    customElements.define('countdown-timer', CountdownTimer);

    // Ensure container is visible
    document.querySelectorAll('.announcement-bar__counter').forEach(el => {
        el.style.display = 'block';
    });
});